<template>
    <div class="d-flex block-message">
        <div class="account__block_image">
            <!-- getAvatar from sidebar -->
            <img :src="getAvatar" alt="">
        </div>
        <div class="d-flex flex-column">
            <div class="author-name">
                <span>{{ author }}</span>
                <span class="comment-created-at">{{ comment.created_at }}</span></div>
            <div class="comment-message">{{ comment.message }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CustomsComment",
    props: {
        comment: {
            type: [Object]
        },
        account: {
            type: [Object]
        },
    },
    data() {
        return {}
    },
    methods: {

    },
    computed: {
        getAvatar() {
            return this.account.avatar;
        },
        author() {
            if (this.comment.admin_id !== null) {
                return this.comment.admin.name + ' ' + this.comment.admin.lastname;
            }
            if (this.comment.user_id !== null) {
                return this.comment.user.first_name_latin + ' ' + this.comment.user.last_name_latin;
            }
        },
    }
}
</script>

<style scoped>

</style>
